export function fileExtension(item) {
    const path = item?.file_path || item?.file_url || ''
    const name = String(path).split('?')[0].split('#')[0].split('/').pop() || ''
    const dot = name.lastIndexOf('.')
    if (dot < 0) return ''
    return name.slice(dot + 1).toLowerCase()
}

export function isSpreadsheet(item) {
    const ext = fileExtension(item)
    return ext === 'xls' || ext === 'xlsx'
}

export function documentKindLabel(item) {
    return isSpreadsheet(item) ? 'Excel' : 'PDF'
}
